import React from 'react';
import { Phone, ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden" data-id="element-92">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-93">
        <img src="https://cdn.magicpatterns.com/uploads/pKeDJQTr3RZtZLEkAJQCrb/hf_20260413_135303_2a8c0046-eacb-4c81-a33d-c04042bd5082.png" alt="C&L Painting Team" className="w-full h-full object-cover object-center" data-id="element-94" />
        <div className="absolute inset-0 bg-brand-black/60 mix-blend-multiply" data-id="element-95"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-brand-black/90 via-transparent to-brand-blue/30" data-id="element-96"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-20" data-id="element-97">
        <div className="max-w-3xl" data-id="element-98">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-99">
            {/* 25th Anniversary Badge */}
            <div className="flex items-center justify-center sm:justify-start gap-3 mb-6" data-id="element-100">
              <div className="hidden sm:block w-10 h-px bg-amber-400/40" data-id="element-101"></div>
              <div className="flex items-center gap-3 border border-amber-400/30 bg-amber-400/5 backdrop-blur-md px-5 py-2.5 rounded-sm" data-id="element-102">
                <span className="text-amber-400/80 font-heading text-[11px] font-bold tracking-[0.2em] uppercase" data-id="element-103">
                  {t.hero.anniversary}
                </span>
                <div className="w-px h-5 bg-amber-400/30" data-id="element-104"></div>
                <span className="text-amber-300 font-heading text-3xl font-extrabold leading-none" data-id="element-105">
                  25
                </span>
                <div className="w-px h-5 bg-amber-400/30" data-id="element-106"></div>
                <span className="text-amber-400/80 font-heading text-[11px] font-bold tracking-[0.2em] uppercase" data-id="element-107">
                  {t.hero.anniversaryTag}
                </span>
              </div>
              <div className="hidden sm:block w-10 h-px bg-amber-400/40" data-id="element-108"></div>
            </div>

            <div className="inline-block bg-brand-blue/80 backdrop-blur-sm text-white px-4 py-1.5 rounded-full text-sm font-bold tracking-wider uppercase mb-6 border border-white/20" data-id="element-109">
              League City, TX
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold text-white leading-tight mb-6 drop-shadow-lg" data-id="element-110">
              {t.hero.headline}
            </h1>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-lg md:text-xl text-gray-200 mb-6 max-w-2xl font-medium leading-relaxed drop-shadow-md" data-id="element-111">
            {t.hero.subheadline}
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="mb-10" data-id="element-112">
            <span className="inline-block bg-white/10 backdrop-blur-sm text-white px-5 py-2 rounded-full text-sm font-bold border border-white/20 tracking-wide" data-id="element-113">
              ✓ {t.hero.badge}
            </span>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="flex flex-col sm:flex-row gap-4" data-id="element-114">
            <a href="tel:8324397965" className="group flex items-center justify-center gap-2 bg-brand-red text-white px-8 py-4 rounded-md font-bold text-lg hover:bg-red-700 transition-all shadow-xl hover:shadow-brand-red/20 hover:-translate-y-0.5 min-h-[56px]" data-id="element-115">
              <Phone className="w-5 h-5" data-id="element-116" />
              {t.hero.primaryCta}
            </a>
            <a href="#portfolio" className="group flex items-center justify-center gap-2 bg-transparent text-white border-2 border-white px-8 py-4 rounded-md font-bold text-lg hover:bg-white hover:text-brand-black transition-all min-h-[56px]" data-id="element-117">
              {t.hero.secondaryCta}
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-118" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}